import  React from "react";
import { Alert } from "reactstrap";
import { FormattedMessage, FormattedNumber } from "react-intl";
import type List from "src/lists/objects/List";
import { RaangeDataTable } from "src/shared/components/data-table/RaangeDataTable";
import RaangeDataTableSort from "src/shared/components/data-table/RaangeDataTableSort";
import {
  ListFirstCreated,
  ListStatus,
} from "src/lists/formatters/ListFormatters";
import {
  NumberSort,
  TemporalSort,
} from "src/shared/components/data-table/RaangeDataSortStrategies";

export interface IListTableProps {
  children: List[];
}

export default ({ children = [] }: IListTableProps) => {
  if (children.length === 0) {
    return (
      <Alert color="info">
        <i className="fas fa-info-circle text-info" />{" "}
        <FormattedMessage id="lists.table.no_lists" />
      </Alert>
    );
  }

  return (
    <RaangeDataTable<List> data={children}>
      {(processedData) => (
        <>
          <thead>
            <tr>
              <th>
                <RaangeDataTableSort<List> sortKey="listName">
                  <FormattedMessage id="lists.list_name" />
                </RaangeDataTableSort>
              </th>
              <th>
                <RaangeDataTableSort<List> sortKey="fileName">
                  <FormattedMessage id="lists.file_name" />
                </RaangeDataTableSort>
              </th>
              <th>
                <RaangeDataTableSort<List> sortKey="description">
                  <FormattedMessage id="lists.description" />
                </RaangeDataTableSort>
              </th>
              <th>
                <RaangeDataTableSort<List>
                  sortKey="rowsSubmitted"
                  sortStrategy={NumberSort}
                >
                  <FormattedMessage id="lists.rows_submitted" />
                </RaangeDataTableSort>
              </th>
              <th>
                <RaangeDataTableSort<List>
                  sortKey="rowsUploaded"
                  sortStrategy={NumberSort}
                >
                  <FormattedMessage id="lists.rows_uploaded" />
                </RaangeDataTableSort>
              </th>
              <th>
                <RaangeDataTableSort<List>
                  sortKey="firstCreated"
                  sortStrategy={TemporalSort}
                >
                  <FormattedMessage id="lists.first_created" />
                </RaangeDataTableSort>
              </th>
              <th />
            </tr>
          </thead>

          <tbody>
            {processedData.map((list) => (
              <tr key={list.listUuid}>
                <th>{list.listName}</th>
                <th>{list.fileName}</th>
                <td>{list.description}</td>
                <td>
                  <FormattedNumber value={list.rowsSubmitted} />
                </td>
                <td>
                  <FormattedNumber value={list.rowsUploaded} />
                </td>
                <td>
                  <ListFirstCreated>{list}</ListFirstCreated>
                </td>
                <td>
                  <ListStatus>{list}</ListStatus>
                </td>
              </tr>
            ))}
          </tbody>
        </>
      )}
    </RaangeDataTable>
  );
};
